module.exports = __webpack_public_path__ + "assets/img/banner2.d560fe79.png";